import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/hourly-salary-calculator',
  component: () => import('../../routes/HourlySalaryCalculator.svelte'),
  card: {
    id: 'hourly-salary-calculator',
    title: 'Hourly to Salary',
    description:
      'Convert your hourly wage to annual, monthly, weekly, and daily salary equivalents. See what your hourly rate means in annual income.',
    icon: 'payments',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/hourly-salary-calculator',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Hourly to Salary Calculator – Convert Hourly Wage to Annual Income',
    description:
      'Free hourly to salary calculator. Enter your hourly wage, hours per week, and weeks per year to instantly see your equivalent annual, monthly, weekly, and daily salary. Perfect for comparing job offers and understanding your true earning power.',
  },
};

export default meta;
